import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { timestamp } from "lib/date";
import { ListInvitation } from "models/list-invitation";
import { Fragment, FunctionComponent, useState } from "react";
import EventsList from "./events-list";
import { ListInvitationEmail } from "models/list-invitation-email";
import { StyledEmail } from "./table.styles";
import { faLink } from "components/icon-library";
import LinkModal from "./link-modal";

interface EmailHistoryTableProps {
  listInvitations: ListInvitation[];
}

const EmailHistoryTable: FunctionComponent<EmailHistoryTableProps> = ({
  listInvitations,
}) => {
  const [link, toggleLink] = useState<ListInvitation | undefined>(undefined);

  const renderSubject = (invitationEmail: ListInvitationEmail) => {
    return (
      <StyledEmail>
        {invitationEmail ? invitationEmail.subject : ""}
      </StyledEmail>
    );
  };

  const columns: ColumnInterface[] = [
    {
      key: "timestamp",
      width: 160,
      header: "Lähetetty",
      render: (invitation: ListInvitation) => timestamp(invitation.created_at),
    },
    {
      key: "email",
      header: "Sähköposti",
      render: (invitation: ListInvitation) => {
        const { listInvitationEmail } = invitation;
        return <Fragment>{renderSubject(listInvitationEmail)}</Fragment>;
      },
    },
    {
      key: "events",
      header: "Tapahtumat",
      render: (invitation: ListInvitation) => {
        const { listInvitationEmail } = invitation;
        if (!listInvitationEmail) {
          return null;
        }
        const { listInvitationEmailEvents = [] } = listInvitationEmail;
        return (
          <EventsList listInvitationEmailEvents={listInvitationEmailEvents} />
        );
      },
      width: 300,
    },
  ];

  return (
    <Fragment>
      <Table
        name="email-history"
        data={listInvitations}
        columns={columns}
        editers={[
          {
            icon: faLink,
            onClick: async (invitation: ListInvitation) =>
              toggleLink(invitation),
          },
        ]}
      />
      {link && (
        <LinkModal
          invitation={link}
          onClose={async () => toggleLink(undefined)}
        />
      )}
    </Fragment>
  );
};

export default EmailHistoryTable;
